import {Form, message} from 'antd'
import {SDrawerOrModal, SGeneralForms, SLowcodeList} from "shj-components";
import {useSetState} from "ahooks";
import {config} from './staffConfig.tsx'
import {employeePermissionsSave, orgPermissionsPage} from "@/services/saleOpServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {useEffect, useRef} from "react";
import {getUserIdentityPage} from "@/services/user.ts";
import {useParams} from "react-router-dom";
import {getRoleList} from "@/services/homeService.ts";
import {isEmpty} from "lodash-es";

export const AddOrEditDom = (props) => {
  const {id} = useParams()
  const {open, setOpen, record, reload, companyList} = props;
  const listRef = useRef()
  const [state, setState] = useSetState({
    loading: false,
    companyObj: {}
  })

  const getSelectedIds = (data) => {
    const result = [];
    const obj = {}
    const handleFn = (tree, res) => {
      tree.reduce((res, item) => {
        const nodeId = item.id;
        isEmpty(state.companyObj) && (obj[item.id] = item);
        res.push(nodeId)
        if (item.children?.length > 0) {
          handleFn(item.children, res)
        }
        return res;
      }, res)
    }
    handleFn(data, result)
    if (isEmpty(state.companyObj)) setState({companyObj: obj})
    return [...new Set(result)]
  }

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      if (query.userNameKeyword) {
        query.employeeFilter = {userNameKeyword: query.userNameKeyword}
        delete query.userNameKeyword
      }
      if (!query.orgIds || query.orgIds?.length <= 0) {
        query.orgIds = getSelectedIds(companyList)
      } else {
        const data = [];
        query.orgIds.map(id => {
          if(state.companyObj[id]){
            data.push(state.companyObj[id])
          }
        })
        query.orgIds = getSelectedIds(data)
      }
      getUserIdentityPage({
        params: {pageId: current, pageSize},
        data: {...query, queryOrg: true, queryEmployee: true}
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onAdd = () => {
    const [_, selectedRows] = listRef.current?.getSelectedRows()
    if (selectedRows.length <= 0) message.error('请至少选择一条数据')
    setState({loading: true})
    const data = selectedRows.map(item => ({
      orgPermissionId: id,
      identityId: item.id,
      userName: item.userName,
      roleId: item.roleId,
    }))
    employeePermissionsSave(data).then(res => {
      message.success(res.message || '操作成功')
      reload()
      setOpen(false)
    }).finally(() => setState({loading: false}))
  }

  const getStatusOptions = async () => {
    return Promise.resolve({
      orgList: companyList,
      roleList: await getRoleList({data: {}}),
    })
  }

  const extension = {
    searchMode: 'group',
    scroll: {y: 350},
    request: {fetchList, getStatusOptions},
  }

  return <SDrawerOrModal
      title={'新增人员'}
      open={open}
      onCancel={() => setOpen(false)}
      loading={state.loading}
      mode={'drawer'}
      width={1000}
      onOk={onAdd}
  >
    <SLowcodeList ref={listRef}
                  config={{...config, searchInitialValues: {orgIds: getSelectedIds(companyList)}}} {...extension}/>
  </SDrawerOrModal>
}